import Vue from 'vue';
import store from "../plugins/store";
export default {
    async index() {
        const response = await Vue.axios.get('/api/v1/countries');
        await store.dispatch('countries/setCountries', response.data);
        return response;
    },
}
